import { useTranslation } from 'react-i18next';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import {
  Typography,
  Grid,
  IconButton,
  Tooltip,
  Zoom,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import Report from '../../components/AdminReportView';
import useStyles from './styles';
import { getAdminReport } from '../../requests/api/report';

const DrawerTooltip = withStyles((theme) => ({
  tooltip: {
    // `secondary.blue` is exactly `custom.brandTooltipBackground`.
    backgroundColor: theme.palette.custom.brandTooltipBackground,
    color: theme.palette.custom.tooltipText,
    textAlign: 'center',
    width: '95px',
    maxWidth: '100%',
    fontSize: '1em',
  },
  arrow: {
    // Was `primary.main`, which never matched the tooltip's own background.
    color: theme.palette.custom.brandTooltipBackground,
    border: '0px',
  },
}))(Tooltip);

function UserReportView() {
  const styles = useStyles();
  const { t } = useTranslation();
  const { userId, reportId } = useParams();
  const [reportName, setReportName] = useState('');
  const handle = useFullScreenHandle();
  const userIdRef = useRef(userId);
  userIdRef.current = userId;

  useEffect(() => {
    const findReport = async () => {
      const response = await getAdminReport(reportId, userIdRef.current);
      if (response.success) {
        const powerbiData = response.data.data.powerbiReport;
        setReportName(powerbiData.reportName);
      }
    };
    findReport();
  }, [reportId, t]);

  return (
    <>
    <br />
    <div className={styles.content}>
      <div >
        <Grid container alignItems='center' justifyContent='space-between'>
          <Grid item>
          <Typography
            className={styles.title}
            variant="h1"
            noWrap
            component={Link}
            gutterBottom
            display="inline"
          >
          <IconButton component={Link} to={`../../../users/${userId}`}>
              <ArrowBackIcon/>
          </IconButton>
          </Typography>
          <Typography variant='subtitle1' className={styles.underlined} gutterBottom display="inline">
            {' / '} {reportName}
          </Typography>
          </Grid>
          <Grid item>
          <DrawerTooltip TransitionComponent={Zoom} placement='right' title={t('reports.fullScreen')} arrow>
            <IconButton onClick={handle.enter}>
              <FullscreenIcon fontSize='large'/>
            </IconButton>
          </DrawerTooltip>
          </Grid>
        </Grid>
    </div>
    <br />
    <FullScreen
    handle={handle}
    >
      <Report fullScreen={handle.active} id={reportId} userId={userId} />
    </FullScreen>
    </div></>
  );
}

export default UserReportView;
